(() => {
  const main = document.querySelector('[data-personalization-language]');
  if (!main) return;
  const english = document.documentElement.lang.toLowerCase().startsWith('en');
  const german = document.documentElement.lang.toLowerCase().startsWith('de');
  const labels = english ? {
    'Souhaitez vous personnaliser le stylo ?': 'Pen personalization',
    'Souhaitez-vous personnaliser le stylo ?': 'Pen personalization',
    'Souhaitez-vous personnaliser le coffret ?': 'Gift box personalization',
    'Personnalisation du stylo': 'Pen personalization',
    'Personnalisation du coffret': 'Gift box personalization',
    'Texte du stylo': 'Pen text',
    'Texte du coffret': 'Gift box text',
    'Oui': 'Yes',
    'Non': 'No',
    'This field is required': 'This field is required',
    'Invalid': 'Invalid entry',
    'Selections will add': 'Selections will add',
    'to the price': 'to the price'
  } : german ? {
    'Souhaitez vous personnaliser le stylo ?': 'Personalisierung des Stifts',
    'Souhaitez-vous personnaliser le stylo ?': 'Personalisierung des Stifts',
    'Souhaitez-vous personnaliser le coffret ?': 'Personalisierung der Geschenkbox',
    'This field is required': 'Dieses Feld ist erforderlich',
    'Invalid': 'Ungültige Eingabe',
    'Selections will add': 'Die Auswahl erhöht den Preis um',
    'to the price': ''
  } : {
    'Souhaitez vous personnaliser le stylo ?': 'Personnalisation du stylo',
    'Souhaitez-vous personnaliser le stylo ?': 'Personnalisation du stylo',
    'Souhaitez-vous personnaliser le coffret ?': 'Personnalisation du coffret',
    'This field is required': 'Ce champ est obligatoire',
    'Invalid': 'Saisie non valide',
    'Selections will add': 'Les options ajoutent',
    'to the price': 'au prix'
  };
  let scheduled = false;
  const translate = () => {
    scheduled = false;
    main.querySelectorAll('.gpo-app .label-content, .gpo-app .gpo-error, .gpo-app .gpo-helptext, .gpo-app .gpo-total-text').forEach(element => {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const text = node.nodeValue.trim();
        if (Object.prototype.hasOwnProperty.call(labels, text)) {
          const value = node.nodeValue.replace(text, labels[text]);
          if (value !== node.nodeValue) node.nodeValue = value;
        }
      }
    });
    main.querySelectorAll('.gpo-app label').forEach(label => {
      const input = label.closest('.gpo-element')?.querySelector('input.gpo-text, textarea.gpo-textarea') || document.getElementById(label.htmlFor);
      if (!input || !main.contains(input)) return;
      const isPen = input.id === 'text-2';
      const isBox = input.id === 'textarea-1';
      const content = label.querySelector('.label-content');
      if (!content || (!isPen && !isBox)) return;
      const value = english ? (isPen ? 'Pen text' : 'Gift box text') : german ? (isPen ? 'Text für den Stift' : 'Text für die Geschenkbox') : (isPen ? 'Texte du stylo' : 'Texte du coffret');
      if (content.textContent.trim() !== value) content.textContent = value;
    });
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(translate);
  };
  translate();
  new MutationObserver(schedule).observe(main, {childList: true, subtree: true, characterData: true});
})();
